<template>
  <div class="ba-flex ba-items-center ba-mb-10">
    <span class="ba-flex-shrink-0 ba-bg-white ba-border ba-rounded">
      <img
        v-if="captchaImageDataUrl"
        class="ba-block"
        alt
        :src="captchaImageDataUrl"
        :style="captchaImageSizeStyle"
      />
      <div v-else :style="captchaImageSizeStyle" />
    </span>
    <vis-refresh-icon
      @click="refreshCaptcha"
      title="Обновить"
      class="ba-flex-shrink-0 ba-cursor-pointer ba-text-gray-500 ba-mx-4 hover:ba-text-default"
    />
    <div class="ba-flex-grow">
      <div class="input-wrap ba-w-full text-center ba-mr-10 ba-mb-1 ba-relative">
        <input
          type="text"
          v-model="captchaFormCode"
          placeholder="Введите код с картинки"
          class="ba-rounded-xl ba-py-2 ba-w-full ba-font-base ba-border-b ba-border-solid"
          maxlength="4"
        />
        <span
          class="vis-icon vis-icon--input"
          :class="{
            'vis-close ba-text-error': captchaIsValid === false,
            'vis-check ba-text-success': captchaIsValid === true
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { captchaMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-captcha",
  mixins: [captchaMixin]
};
</script>
